import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M8.30829 2.92439C8.41991 3.37088 8.14845 3.82333 7.70195 3.93495L3.33317 5.02715V14.5592L7.29772 13.568C7.74422 13.4564 8.19667 13.7279 8.30829 14.1744C8.41991 14.6209 8.14845 15.0733 7.70195 15.185L2.70195 16.435C2.453 16.4972 2.18926 16.4413 1.98699 16.2833C1.78473 16.1254 1.6665 15.8831 1.6665 15.6265V4.3765C1.6665 3.99411 1.92675 3.66079 2.29772 3.56805L7.29772 2.31805C7.74422 2.20642 8.19667 2.47789 8.30829 2.92439Z",
      fill: "#0A072D"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.06173 2.41743C7.30741 2.26559 7.61419 2.25179 7.87252 2.38095L12.8725 4.88095C13.1548 5.02211 13.3332 5.31066 13.3332 5.6263V16.8763C13.3332 17.1651 13.1836 17.4333 12.9379 17.5852C12.6923 17.737 12.3855 17.7508 12.1272 17.6217L7.12716 15.1217C6.84484 14.9805 6.6665 14.6919 6.6665 14.3763V3.1263C6.6665 2.83749 6.81605 2.56927 7.06173 2.41743ZM8.33317 4.47466V13.8613L11.6665 15.5279V6.14133L8.33317 4.47466Z",
      fill: "#0A072D"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M18.0129 3.71947C18.2151 3.87739 18.3334 4.1197 18.3334 4.37631V15.6263C18.3334 16.0087 18.0731 16.342 17.7021 16.4348L12.7021 17.6848C12.2557 17.7964 11.8032 17.5249 11.6916 17.0784C11.58 16.6319 11.8514 16.1795 12.2979 16.0679L16.6667 14.9757V5.44362L12.7021 6.43476C12.2557 6.54639 11.8032 6.27492 11.6916 5.82842C11.58 5.38193 11.8514 4.92948 12.2979 4.81786L17.2979 3.56786C17.5469 3.50562 17.8106 3.56155 18.0129 3.71947Z",
      fill: "#0A072D"
    }, null, -1)
  ])))
}
export default { render: render }